import React, { useState, useEffect } from "react";
import Button from "olive-react-myoneui/lib/Button";
import SampleImage2 from "../../../assets/images/sample2.jpg";
import IconDesc from "../my-course/IconDesc";
import { bookIcon, geoMarkIcon, checkCircleIcon, boxOIcon } from "../../../constants/icons";
import Container from "olive-react-myoneui/lib/Container";
import Row from "olive-react-myoneui/lib/Row";
import Col from "olive-react-myoneui/lib/Col";
import Card from "olive-react-myoneui/lib/Card";
import EventScheduleList from "./EventScheduleList";
import moment from 'moment';

function CourseEventSchedules({selectedTimeZone, eventSessions, setTotalLecturesCount, setTotalCoursesCount, className}) {
  return (
    <div className={`${className || ""}`} >
      <Container>
        <Row className="align-items-center">
          <Col lg={12}>
            <div className="bundle-courses-events p-0">
              <h4 className="fw-bold">Sessions</h4>
            </div>
          </Col>
          <Col lg={12}>
            <Card className="border-0">
              <Card.Body className="p-0">
                <Row>
                  <Col lg={12} className="mb-0">
                    {
                      eventSessions?.map((session, i) => {
                        if (eventSessions.length - 1 == i) {
                          return <EventScheduleList selectedTimeZone={selectedTimeZone} setTotalLecturesCount={setTotalLecturesCount} setTotalCoursesCount={setTotalCoursesCount} key={i} session={session} slno={i}/>
                        }
                      })
                    }
                  </Col>
                  {/* <Col lg={12} className="mb-3">
                    <EventScheduleList />
                  </Col> */}
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CourseEventSchedules;
